export const spotlight = [
  {
    name: "Rory Sutherland",
    role: "Vice Chairman, Ogilvy",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Show+First/Rory+Sutherland%2C+Vice+Chairman%2C+Ogilvy.png",
  },
  {
    name: "Benedict Evans",
    role: "World Renowned Tech Analyst",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Show+First/Benedict+Evans+-+World+Renowned+Tech+Analyst.png",
  },
  {
    name: "Dan Ariely",
    role: "Professor, Duke University",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Show+First/Dan+Ariely+-+Professor%2C+Duke+University.jpg",
  },
  {
    name: "Josy Paul",
    role: "Chairman, BBDO India",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Show+First/Josy+Paul+-+Chairman%2C+BBDO+India.jpeg",
  },
];

export const featuredWomen = [
  {
    name: "Amanda Feve",
    role: "Partner, CSO, Anomaly",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Female/Amanda+Feve+-+Partner%2C+CSO%2C+Anomaly.jpg",
  },
  {
    name: "Amanda Russell",
    role: "Marketing Professor, University of Texas",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Female/Amanda+Russell+-+Marketing+Professor%2C+University+of+Texas.png",
  },
  {
    name: "Ann Mukherjee",
    role: "CEO, Pernod Ricard",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Female/Ann+Mukherjee+-+CEO%2C+Pernod+Ricard.jpg",
  },
  {
    name: "Anna Arnell",
    role: "CD, Wieden+Kennedy",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Female/Anna+Arnell+-+CD%2C+Wieden%2BKennedy.jpg",
  },
  {
    name: "Anna Vogt",
    role: "Global CSO, Edelman",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Female/Anna+Vogt+-+Global+CSO%2C+Edelman.jpg",
  },
  {
    name: "Debbie Vandeven",
    role: "Global CCO, VML",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Female/Debbie+Vandeven+-+Global+CCO%2C+VML.png",
  },
  {
    name: "Fura Johannesdottir",
    role: "Global CCO",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Female/Fura+Johannesdottir+-+Global+CCO%2C+Interbrand.png",
  },
  {
    name: "Hanan Belarbi",
    role: "Data & AI Leader",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Female/Hanan+Belarbi+-+Data+%26+AI+Leader.png",
  },
  {
    name: "Jane Evans",
    role: "Founder, The Uninvisibility Project",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Female/Jane+Evans+-+Founder%2C+The+Uninvisibility+Project.jpg",
  },
  {
    name: "Karen Boswell",
    role: "Global CEO, M+C Saatchi",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Female/Karen+Boswell+-+Global+CEO%2C+M%2BC+Saatchi.png",
  },
  {
    name: "Kate Toon",
    role: "Copywriter & Marketing Coach",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Female/Kate+Toon+-+Copywriter+%26+Marketing+Coach.jpg",
  },
  {
    name: "Kate van der Borgh",
    role: "Copywriter & Trainer",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Female/Kate+van+der+Borgh+-+Copywriter+%26+Trainer.jpg",
  },
  {
    name: "Kathryn Jacob OBE",
    role: "CEO, Pearl & Dean",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Female/Kathryn+Jacob+OBE+-+CEO%2C+Pearl+%26+Dean.jpg",
  },
  {
    name: "Laura Jordan Bambach",
    role: "CCO, Uncharted",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Female/Laura+Jordan+Bambach%2C+CCO%2C+Uncharted.jpeg",
  },
  {
    name: "Melissa Wildermuth",
    role: "CCO, General Mills",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Female/Melissa+Wildermuth+-+CCO%2C+General+Mills.jpeg",
  },
  {
    name: "Shannie Mears",
    role: "Founder, The Elephant Room",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Female/Shannie+Mears+-+Founder%2C+The+Elephant+Room+.png",
  },
  {
    name: "Tara Austin",
    role: "Partner, Ogilvy Consulting",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Female/Tara+Austin+-+Partner%2C+Ogilvy+Consulting.png",
  },
  {
    name: "Tyrona Heath",
    role: "Co‑Founder, The B2B Institute at LinkedIn",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Female/Tyrona+Heath+-+Co%E2%80%91Founder%2C+The+B2B+Institute+at+LinkedIn.jpg",
  },
  {
    name: "Vicki Maguire",
    role: "CCO, Havas",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Female/Vicki+Maguire+-+CCO%2C+Havas.png",
  },
  {
    name: "Vikki Ross",
    role: "Brand, Tone of Voice & Copy Consultant",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Female/Vikki+Ross+-+Brand%2C+Tone+of+Voice+%26+Copy+Consultant.jpg",
  },
];

export const generalPool = [
  {
    name: "Anthony Kennedy",
    role: "CMO, ION",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Anthony+Kennedy+-+CMO%2C+ION.jpeg",
  },
  {
    name: "Ben Jones",
    role: "Founder, Sundogs ex-Google",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Ben+Jones+-+Founder%2C+Sundogs+ex-Google.jpeg",
  },
  {
    name: "Bruno Bertelli",
    role: "Global CCO, Publicis",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Bruno+Bertelli+-+Global+CCO%2C+Publicis.jpeg",
  },
  {
    name: "Dan Bennett",
    role: "Head of Behavioural Science, Ogilvy",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Dan+Bennett+-+Head+of+Behavioural+Science%2C+Ogilvy.jpeg",
  },
  {
    name: "Dave Trott",
    role: "Advertising Legend",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Dave+Trott+-+Advertising+Legend.jpg",
  },
  {
    name: "Derek Walker",
    role: "Founder, Brown+Browner",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Derek+Walker+-+Founder%2C+Brown%2BBrowner.jpg",
  },
  {
    name: "Dr Jules Goddard",
    role: "Professor, London Business School",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Dr+Jules+Goddard+-+Professor%2C+London+Business+School.png",
  },
  {
    name: "Fonz Morris",
    role: "Lead Designer, Netflix",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Fonz+Morris+-+Lead+Designer%2C+Netflix.png",
  },
  {
    name: "Frank Cooper III",
    role: "CMO, Black Rock",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Frank+Cooper+III+-+CMO%2C+Black+Rock.png",
  },
  {
    name: "Frank Stephenson",
    role: "Founder, Frank Stephenson Design",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Frank+Stephenson+-+Founder%2C+Frank+Stephenson+Design.jpg",
  },
  {
    name: "Harjot Singh",
    role: "Global CSO, McCann",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Harjot+Singh+-+Global+CSO%2C+McCann.jpeg",
  },
  {
    name: "James Rosenthal",
    role: "Director of AI Infrastructure, Google",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/James+Rosenthal+-+Director+of+AI+Infrastructure%2C+Google.png",
  },
  {
    name: "Keith Reinhard",
    role: "Chairman Emeritus, DDB Worldwide",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Keith+Reinhard+-+Chairman+Emeritus%2C+DDB+Worldwide.jpg",
  },
  {
    name: "Keith Weed",
    role: "Ex-Global CMO, Unilever",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Keith+Weed+-+Ex-Global+CMO%2C+Unilever.jpeg",
  },
  {
    name: "Kervins Chauvet",
    role: "Wieden+Kennedy",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Kervins+Chauvet+-+Wieden%2BKennedy.png",
  },
  {
    name: "Les Binet",
    role: "Head of Effectivness, adam&eveDDB",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Les+Binet+-+Head+of+Effectivness%2C+adam%26eveDDB+.jpg",
  },
  {
    name: "Mark Sandys",
    role: "CMO, Diageo",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Mark+Sandys+-+CMO%2C+Diageo.jpeg",
  },
  {
    name: "Matt Johnson",
    role: "Writer, Economist",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Matt+Johnson+-+Writer%2C+Economist.jpeg",
  },
  {
    name: "Meik Wiking",
    role: "Author CEO, Happiness Research Institute",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Meik+Wiking+-+Author+CEO%2C+Happiness+Research+Institute.jpg",
  },
  {
    name: "Michael Pawlyn",
    role: "Architect & Director, Exploration Architecture",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Michael+Pawlyn+-+Architect+%26+Director%2C+Exploration+Architecture.png",
  },
  {
    name: "Mick McCabe",
    role: "Global CSO, Ogilvy",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Mick+McCabe+-+Global+CSO%2C+Ogilvy.jpg",
  },
  {
    name: "Neo Mashigo",
    role: "CCO, M&C Saatchi Abel",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Neo+Mashigo+-+CCO%2C+M%26C+Saatchi+Abel.jpeg",
  },
  {
    name: "Nils Leonard",
    role: "Founder, Uncommon",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Nils+Leonard+-+Founder%2C+Uncommon.jpeg",
  },
  {
    name: "Orland Wood",
    role: "CSO, System 1",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Orland+Wood+-+CSO%2C+System+1.png",
  },
  {
    name: "Patrick Collister",
    role: "Ex-Creative Director, Google",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Patrick+Collister+-+ex-Creative+Director%2C+Google.png",
  },
  {
    name: "Peter Field",
    role: "Marketing Effectivness Expert",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Peter+Field+-+Marketing+Effectivness+Expert.png",
  },
  {
    name: "Piyush Pandey",
    role: "Global CCO, Ogilvy",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Piyush+Pandey+-Global+CCO%2C+Ogilvy.jpeg",
  },
  {
    name: "Rei Inamoto",
    role: "Founding Partner, I&CO",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Rei+Inamoto+-+Founding+Partner%2C++I%26CO.png",
  },
  {
    name: "Rob Reilly",
    role: "Global CCO, WPP",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Rob+Reilly+-+Global+CCO%2C+WPP.jpg",
  },
  {
    name: "Rupert Soar",
    role: "Professor Nottingham Trent University",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Rupert+Soar+-+Professor+Nottingham+Trent+University.jpg",
  },
  {
    name: "Simon Vickars",
    role: "CCO, Colenso BBDO",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Simon+Vickars+-+CCO%2C+Colenso+BBDO.jpg",
  },
  {
    name: "Sir John Hegarty",
    role: "Founder, BBH",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Sir+John+Hegarty+-+Founder%2C+BBH.png",
  },
  {
    name: "Sir Martin Sorrell",
    role: "Chairman, S4 Capital",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Sir+Martin+Sorrell+-+Chairman%2C+S4+Capital.jpg",
  },
  {
    name: "Steve Harrison",
    role: "ex-Global ECD, Wunderman",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Steve+Harrison+-+ex-Global+ECD%2C+Wunderman.jpg",
  },
  {
    name: "Thomas Kolster",
    role: "Founder, Goodvertising Agency",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Thomas+Kolster+-+Founder%2C+Goodvertising+Agency.jpg",
  },
  {
    name: "Wayne Best",
    role: "CCO, VML",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Wayne+Best+-+CCO%2C+VML.jpeg",
  },
  {
    name: "Will Awdry",
    role: "Writing Coach & Strategist",
    avatar:
      "https://42coursescombo-production.s3.eu-west-1.amazonaws.com/Thought+Leaders/Will+Awdry+-+Writing+Coach+%26+Strategist.jpg",
  },
];
